import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TeacherNotificationService {
  private API = environment.API_URL;
  private notificationsSubject = new BehaviorSubject<TeacherNotification[]>([]);
  private unreadCountSubject = new BehaviorSubject<number>(0);

  public notifications$ = this.notificationsSubject.asObservable();
  public unreadCount$ = this.unreadCountSubject.asObservable();

  constructor(private http: HttpClient) {}

  loadNotifications(status: 'pending' | 'read' | 'dismissed' = 'pending'): void {
    this.http.get<any>(`${this.API}/teacher-notifications`, {
      params: { status }
    }).subscribe({
      next: (response) => {
        if (response.success) {
          this.notificationsSubject.next(response.data.notifications);
          this.unreadCountSubject.next(response.data.unread_count);
        }
      },
      error: (error) => console.error('Error loading notifications:', error)
    });
  }

  getUnreadCount(): Observable<number> {
    return this.http.get<any>(`${this.API}/teacher-notifications/unread-count`)
      .pipe(
        map(response => response.data.unread_count),
        tap(count => this.unreadCountSubject.next(count))
      );
  }

  markAsRead(notificationId: number): Observable<any> {
    return this.http.post(
      `${this.API}/teacher-notifications/${notificationId}/mark-as-read`,
      {}
    ).pipe(
      tap(() => this.loadNotifications())
    );
  }

  dismiss(notificationId: number): Observable<any> {
    return this.http.post(
      `${this.API}/teacher-notifications/${notificationId}/dismiss`,
      {}
    ).pipe(
      tap(() => this.loadNotifications())
    );
  }

  markAllAsRead(): Observable<any> {
    return this.http.post(
      `${this.API}/teacher-notifications/mark-all-as-read`,
      {}
    ).pipe(
      tap(() => this.loadNotifications())
    );
  }
}

export interface TeacherNotification {
  id: number;
  teacher_id: number;
  action_type: 'proof_qualification' | 'practice_evaluation';
  entity_type: string;
  entity_id: number;
  title: string;
  description: string;
  action_url: string;
  priority: 'low' | 'medium' | 'high';
  status: 'pending' | 'read' | 'dismissed';
  read_at: string | null;
  dismissed_at: string | null;
  created_at: string;
  updated_at: string;
}
